import { Routes } from '@angular/router';
import { RouteSubComponent } from 'authorization';
import { SiteManagmentRoute } from './site-managment.route';
import { faqRouting } from './app/feature/faq/faq.routing';
import { termRouting } from './app/feature/term/term.routing';
import { logsRouting } from './app/feature/logs/logs.routing';
import { blackListRouting } from './app/feature/black-list/black-list.routing';
import { RouteLazyComponent } from 'authorization';
export const SiteManagmentRouting: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'mainpage',
  },
  {
    path: 'blank_layout',
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/no-layout/no-layout.component'
      ).then((c) => c.NoLayoutComponent),
    children: [
      {
        path: 'maintenance_mode',
        data: {
          breadcrumb: {
            skip: true,
          },
          title: '',
        },
        loadComponent: () =>
          import('catch-error').then((m) => m.MaintenanceComponent),
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.blank_layout,
        'maintenance_mode'
      >,
    ],
  },

  {
    path: 'mainpage',
    loadComponent: () =>
      import(
        'src/app/component/main-page-layout/main-page-layout.component'
      ).then((c) => c.MainPageLayoutComponent),
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
    children: [
      {
        path: '',

        loadComponent: () =>
          import('./app/component/app-home-page/app-home-page.component').then(
            (m) => m.AppHomePageComponent,
          ),
      } as RouteSubComponent<typeof SiteManagmentRoute.map, 'root'>,
      {
        path: 'not_found',
        loadComponent: () =>
          import('./app/component/not-found/not-found.component').then(
            (m) => m.NotFoundComponent,
          ),
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.mainpage,
        'not_found'
      >,
    ],
  } as RouteLazyComponent<typeof SiteManagmentRoute.map, 'mainpage'>,

  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((m) => m.FullLayoutComponent),
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
    children: [
      {
        path: 'contact_requests',
        loadComponent: () =>
          import(
            './app/component/contact-requests/contact-requests.component'
          ).then((m) => m.ContactRequestsListComponent),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'contact_requests'
      >,
      {
        path: 'edit_main_page',
        loadComponent: () =>
          import(
            './app/component/edit-main-page/app-edit-home-page.component'
          ).then((m) => m.AppEditHomePageComponent),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'edit_main_page'
      >,
      {
        path: 'config_system',
        loadComponent: () =>
          import('./app/component/system-config/system-config.component').then(
            (m) => m.SystemConfigComponent,
          ),
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'config_system'
      >,
      {
        path: 'app_notification_panel_list',
        loadComponent: () =>
          import(
            './app/component/app-notification-panel-list/app-notification-panel-list.component'
          ).then((m) => m.AppNotificationPanelListComponent),
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'app_notification_panel_list'
      >,
      {
        path: 'app_notification_panel_edit',
        loadComponent: () =>
          import(
            './app/component/app-notification-panel-edit/app-notification-panel-edit.component'
          ).then((m) => m.AppNotificationPanelEditComponent),
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'app_notification_panel_edit'
      >,
      {
        path: 'admin_active_sessions',
        loadComponent: () =>
          import(
            './app/component/admin-active-sessions/admin-active-sessions.component'
          ).then((m) => m.AdminActiveSessionsComponent),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'admin_active_sessions'
      >,
      {
        path: 'active_sessions',
        loadComponent: () =>
          import(
            './app/component/active-sessions/active-sessions.component'
          ).then((m) => m.ActiveSessionsComponent),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'active_sessions'
      >,

      {
        path: 'panel_menu',
        loadComponent: () =>
          import(
            '../../app/component/app-vertical-menu/app-vertical-menu.component'
          ).then((m) => m.AppVerticalMenuComponent),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<
        typeof SiteManagmentRoute.map.dashboard,
        'panel_menu'
      >,
    ],
  } as RouteLazyComponent<typeof SiteManagmentRoute.map, 'dashboard'>,

  {
    path: 'faq',
    children: [...faqRouting],
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
  } as RouteLazyComponent<typeof SiteManagmentRoute.map, 'faq'>,

  {
    path: 'term',
    children: [...termRouting],
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
  } as RouteLazyComponent<typeof SiteManagmentRoute.map, 'term'>,

  {
    path: 'logs',
    children: [...logsRouting],
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
  } as RouteLazyComponent<typeof SiteManagmentRoute.map, 'logs'>,

  {
    path: 'black_list',
    children: [...blackListRouting],

    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
  } as RouteLazyComponent<typeof SiteManagmentRoute.map, 'black_list'>,
];
